import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {CustomValidators} from '@app/+auth/shared/validator/custom.validators';
import {Router} from '@angular/router';
import {Path} from '@core/enums';
import {AuthService} from '@app/+auth/shared/services/auth.service';
import { pickBy, identify } from 'lodash';
import { ToastrService } from 'ngx-toastr';
import {MatDialog} from '@angular/material/dialog';

@Component({
  templateUrl: './sign-up.page.html',
  styleUrls: ['./sign-up.page.scss']
})
export class SignUpPage implements OnInit {

  constructor(
    private authService: AuthService,
    private router: Router,
    private dialog: MatDialog,
    private toastr: ToastrService) { }

  mobileScreen: boolean;
  hide = true; // For password
  hide2 = true; // For confirm password

  // TODO: Should retrieve from backend
  countries = [
    'Ireland',
    'United Kingdom'
  ];

  isChecked = false; // Check if Privacy is checked.

  // Sign up form form validation
  signUpForm = new FormGroup({
    firstName: new FormControl('', [
      Validators.required,
    ]),
    lastName: new FormControl('', [
      Validators.required,
    ]),
    email : new FormControl('', [
      Validators.required,
      Validators.email,
    ]),
    country : new FormControl(null, [
      Validators.required,
    ]),
    password: new FormControl('', [
      Validators.required,
      // At least 8 characters in length, at least one letter, one number and one special character
      // tslint:disable-next-line:max-line-length
     //  Validators.pattern('^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=_()]).*$')
     // Validators.pattern('^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[!-\/:-@[-`{-~]).*$')
      Validators.pattern('^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[\\W_]).*$')
    ]),
    confirmPasswordFormControl: new FormControl('', [
      Validators.required,
      Validators.pattern('^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[\\W_]).*$')
    ])
  }, {validators: CustomValidators.passwordConfirmation} );

  // For Sign up form Details
  get firstName() {
    return this.signUpForm.get('firstName');
  }
  get lastName() {
    return this.signUpForm.get('lastName');
  }
  get email() {
    return this.signUpForm.get('email');
  }
  get country() {
    return this.signUpForm.get('country');
  }
  get password() {
    return this.signUpForm.get('password');
  }
  get confirmPasswordFormControl() {
    return this.signUpForm.get('confirmPasswordFormControl');
  }

  get isTherapistSignup() {
    // Removes the '/' at the start or url
    return this.router.url.substring(1) === Path.TherapistSignUp;
  }

  ngOnInit(): void {
    if (window.screen.width <= 400) {
      this.mobileScreen = true;
    }

    if (this.isTherapistSignup) {
      this.country.setValidators(null);
    }
  }

  onSignupSubmit(templateRef){
    if (this.isChecked) {
      const signUpFormDetails = this.signUpForm.value;
      delete signUpFormDetails.confirmPasswordFormControl;

      signUpFormDetails.userType = this.isTherapistSignup ? 'therapist' : 'parent';

      // Used to remove undefined `country` field if user is a therapist
      const filteredFormDetails = pickBy(signUpFormDetails, identify);

      this.authService.signup(filteredFormDetails).subscribe((response) => {
        if (response.status === 200) {
          this.handleSuccessfulResponse(templateRef);
        }
      }, ((error) => this.handleErrorResponse(error)));
    }else {
      this.toastr.info('Please read the privacy policy');
    }

  }

  handleSuccessfulResponse = (templateRef) => {
   // this.toastr.success('Please activate your account from your email', 'Success!');
    this.openSignupSuccessDialog(templateRef);
    this.onSignIn();
  }

  handleErrorResponse = (error) => {
    const message = [401, 403, 406].includes(error.status)
      ? error.error.message
      : error.error.error;

    this.toastr.error(message, 'Error!');
  }

  onSignIn(){
    this.router.navigate([`${Path.App}/${Path.SignIn}`]);
  }

  openPrivacyDialog(templateRef) {
    const dialogRef = this.dialog.open(templateRef);
    dialogRef.afterClosed().subscribe(result => {
     console.log('Result', result);
    });
  }

  openTermsServiceDialog(templateRef) {
    const dialogRef = this.dialog.open(templateRef);
    dialogRef.afterClosed().subscribe(result => {
      console.log('Result', result);
    });
  }

  openSignupSuccessDialog(templateRef) {
    const dialogRef = this.dialog.open(templateRef);
    dialogRef.afterClosed().subscribe(result => {
      console.log('Result', result);
    });
  }
}
